import React from 'react';
import MapContext from '../context';

import PropTypes from 'prop-types';

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';

import '../styles/CategoryGroupLayerPicker.css'

import { Stack } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Slider } from '@mui/material';

import CategoryGroupLayerRenderer from './CategoryGroupLayerRenderer';

const selectionTypes = {
  monoselective: 'monoselective',
  polyselective: 'polyselective',
}

const getOpacitySlider = (opacity, handleOpacityChange) => {
  return (
    <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
      <VisibilityOff className='clicky' onClick={() => { handleOpacityChange(null, 0)}}/>
      <Slider aria-label="Volume" value={opacity * 100} onChange={handleOpacityChange} step={1} min={0} max={100}/>
      <Visibility className='clicky' onClick={() => { handleOpacityChange(null, 100)}} />
    </Stack>
  );
  
}

const getSelectType = (selectionType, isSelected, labelId) => {
  if (selectionType === selectionTypes.monoselective) {
    return (
      <Radio
        edge="start"
        checked={isSelected}
        disableRipple
        inputProps={{ 'aria-labelledby': labelId }}
      />
    );
  } else {
    return (
      <Checkbox
        edge="start"
        checked={isSelected}
        tabIndex={-1}
        disableRipple
        inputProps={{ 'aria-labelledby': labelId }}
      />
    );
  }
}

const LayerRenderer = ({category, layer, updateGroup, keyVal}) => {
  const [, setLayerOpacity] = React.useState(layer?.getOpacity() || 1);
  const [, setSelected] = React.useState(category.getSelectionKeys().includes(layer.key) || false);
  const labelId = `checkbox-list-label-${layer.key}`;
  const selectionType = category.getSelectionType();
  const isSelected = category.getSelectionKeys().includes(layer.key);

  const selectLayer = () => {
    category.selectLayer(layer.key);
    setSelected(true);
  }

  const deselectLayer = () => {
    category.deselectLayer(layer.key);
    setSelected(false);
  }

  const toggle = () => {     
    if (selectionType === selectionTypes.monoselective) {
      selectLayer();
      updateGroup();
    } else {
      if (!isSelected) {
        selectLayer();
      } else {
        deselectLayer();
      }
    }
  };

  

  return (
    <div className="layer" key={keyVal} >
      <ListItem
        key={layer.key}
        secondaryAction={ isSelected && category.isMultiphasic() ? 
          getOpacitySlider(layer.getOpacity(), (event, value) => {
            layer.setOpacity(value / 100);
            setLayerOpacity(value / 100);
          })
          : null
        }
        disablePadding
      >
        <ListItemButton role={undefined} onClick={toggle} dense>
          <ListItemIcon>
            {getSelectType(selectionType, isSelected, labelId)}
          </ListItemIcon>
          <ListItemText className="layer-name" id={labelId} primary={layer.name} />
        </ListItemButton>
      </ListItem>
    </div>
  )
}

LayerRenderer.propTypes = {
  category: PropTypes.object,
  layer: PropTypes.object,
  updateGroup: PropTypes.func,
  keyVal: PropTypes.any,
}



const LayerPicker = ({categories}) => {
  const map = React.useContext(MapContext);


  if(map && categories )
    return (<CategoryGroupLayerRenderer categories={categories} LayerRenderer={LayerRenderer} />);
  else
    return ( <div>Loading...</div> );
}

LayerPicker.propTypes = {
  categories: PropTypes.array,
  config:  PropTypes.any,
}


export default LayerPicker;